// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".company[data-v-df0f01ec]{letter-spacing:1px}.contact[data-v-df0f01ec]{height:100%}.bg[data-v-df0f01ec]{background-size:cover;background-position:center center;min-height:100vh;width:100%;top:0;left:0;position:fixed;z-index:0;opacity:.2}.container[data-v-df0f01ec]{position:relative}", ""]);
// Exports
module.exports = exports;
